import { useState } from "react";
import { Card, CardBody, Col, Collapse } from "reactstrap";
import { Rating } from "react-simple-star-rating";
import CommonLearningHeader from "./Common/CommonLearningHeader";
import { CourseBy, Href, UpcomingCoursesHeading } from "../../../../Constant";
import { UPCOMING_COURSE_DATA } from "../../../../Data/Learning";
import { Link } from "react-router-dom";
import { H5 } from "../../../../AbstractElements";

const UpcomingCourses = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Col xl="12">
      <Card>
        <CommonLearningHeader heading={UpcomingCoursesHeading} isOpen={isOpen} setIsOpen={setIsOpen} />
        <Collapse isOpen={isOpen}>
          <CardBody className="upcoming-course">
            {UPCOMING_COURSE_DATA.map((data, index) => (
              <div className="d-flex" key={index}>
                <div className="flex-grow-1">
                  <span className="f-w-700">{data.courseHeading}</span>
                  <span className="d-block">
                    {CourseBy} <Link to={Href} className="f-w-700">{data.courseTeam}</Link>
                  </span>
                  <Rating className="rating ms-1" fillColor="#feb858" initialValue={Math.random() * 5} size={20} />
                </div>
                <div>
                  <H5 className="mb-0 font-primary">{data.courseDate}</H5>
                  <span className="d-block">{data.courseMonth}</span>
                </div>
              </div>
            ))}
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};

export default UpcomingCourses;
